import styles from './Swap.module.css';
import { useEffect, useState } from 'react';
import {
  SwapHeader,
  CurrencyConverter,
  ExtraInfo,
  Button,
} from '../../components';
import Limit from '../Limit/Limit';
import ContentContainer from '../../components/misc/ContentContainer/ContentContainer';
const Swap = () => {
  const [allowedButton, setAllowedButton] = useState(false);
  const [showTrade, setShowTrade] = useState(false);

  const sellQty = document.getElementById('sell-quantity')?.value;
  function handleAllowedButton() {
    if (isNaN(sellQty) || sellQty === 0 || sellQty < 0) {
      setAllowedButton(false);
    } else {
      setAllowedButton(true);
    }
  }
  useEffect(() => {
    handleAllowedButton();
  }, [sellQty]);

  const ButtonDisplay = (
    <div className={styles.button_container}>
      <Button title={allowedButton ? 'Swap' : 'Enter an amount'} disabled />
    </div>
  );

  const SwapContent = (
    <>
      <CurrencyConverter />

      <ExtraInfo />
      {ButtonDisplay}
    </>
  );

  const LimitContent = (
    <>
      <Limit />
    </>
  );

  const toggleButtons = (
    <div className={styles.market_toggle_buttons_container}>
      <button
        className={!showTrade ? styles.active_button : styles.non_active_button}
        onClick={() => setShowTrade(!showTrade)}
      >
        Market
      </button>
      <button
        className={showTrade ? styles.active_button : styles.non_active_button}
        onClick={() => setShowTrade(!showTrade)}
      >
        Limit
      </button>
    </div>
  );
  return (
 
          <ContentContainer>
          <SwapHeader />
          {toggleButtons}
          {showTrade ? LimitContent : SwapContent}

          </ContentContainer>
          
   
  );
};

export default Swap;
